import { render, staticRenderFns } from "./SpotIoForm.vue?vue&type=template&id=7e64af1c"
import script from "./SpotIoForm.vue?vue&type=script&lang=js"
export * from "./SpotIoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports